import { render, staticRenderFns } from "./IndicatorDeleteModal.vue?vue&type=template&id=010046ef&scoped=true"
import script from "./IndicatorDeleteModal.vue?vue&type=script&lang=js"
export * from "./IndicatorDeleteModal.vue?vue&type=script&lang=js"
import style0 from "./IndicatorDeleteModal.vue?vue&type=style&index=0&id=010046ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010046ef",
  null
  
)

export default component.exports